export default __webpack_public_path__ + "static/media/README.1e5c5d56.md";